// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  padding: 16px;
}
@media (max-width: 480px) {
  .ModalOverlay {
    padding: 0;
  }
}

.Modal {
  position: relative;
  display: grid;
  grid-template-rows: auto 1fr auto;
  box-sizing: border-box;
  background: white;
  border-radius: 8px;
  outline: none;
  overflow: hidden;
}
@media (max-width: 1024px) {
  .Modal {
    width: 90%;
  }
}
@media (max-width: 768px) {
  .Modal {
    min-width: unset;
    width: 100%;
  }
}
@media (max-width: 480px) {
  .Modal {
    min-width: unset;
    width: 100%;
  }
  .Modal:not(.Modal--centered) {
    border-radius: 0;
  }
}
.Modal h2 {
  color: #374145;
  font-weight: 500;
  font-size: 1.125rem;
}
.Modal h2::first-letter {
  text-transform: capitalize;
}
.Modal__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px;
  border-bottom-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
  z-index: 1;
  min-width: 0;
}
.Modal__head__left {
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
}
.Modal__head__left .Button {
  margin-left: 30px;
}
.Modal__head__left *::first-letter {
  text-transform: uppercase;
}
.Modal__body {
  overflow-y: auto;
  overflow-x: hidden;
}
.Modal__body .group-wrapper {
  display: grid;
  align-items: center;
  grid-template-columns: 3fr 9fr;
  margin-top: 20px;
}
.Modal__body .group-wrapper:first-child {
  margin-top: 0;
}
.Modal__body .group-wrapper label {
  line-height: 1.1;
  font-size: 0.875rem;
}
.Modal__body .group-wrapper .react-datepicker__input-container input {
  width: 100%;
  font-size: 0.875rem;
}
.Modal__body .group-wrapper textarea {
  border-radius: 6px;
  border: 1px solid #252b37;
  padding: 8px 10px;
  font-size: 0.875rem;
  font-family: "Geist", sans-serif;
  color: #252b37;
  resize: none;
}
.Modal__body .group-wrapper textarea:focus {
  outline: none !important;
}
.Modal__body .group-wrapper textarea::placeholder {
  color: #252b37;
}
.Modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding: 12px 16px;
  border-top: 1px;
  border-top-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
  background-color: #fff;
}
.Modal__footer .Button--secondary {
  background: transparent;
  color: #252b37;
}
.Modal__footer .Button--secondary:hover {
  background: #f9fafa;
}
.Modal__footer .Button--transparent {
  color: #aaaaaa;
}
.Modal__footer .Button--transparent:hover {
  background-color: #efefef;
}
.Modal--Receipt {
  width: auto;
  min-width: 1000px;
}
@media (max-width: 1512px) {
  .Modal--Receipt {
    min-width: 900px;
  }
}
@media (max-width: 1024px) {
  .Modal--Receipt {
    min-width: unset;
    width: 90%;
  }
}
@media (max-width: 768px) {
  .Modal--Receipt {
    width: 96%;
  }
}
.Modal--Receipt .Modal__head {
  padding: 0;
  border-bottom: 0;
}
.Modal--Receipt .Modal__head .Button--close {
  position: absolute;
  top: 20px;
  right: 40px;
  z-index: 2;
  background-color: transparent;
}
@media (max-width: 480px) {
  .Modal--Receipt .Modal__head .Button--close {
    top: 14px;
    right: 34px;
  }
}
.Modal--Receipt .Modal__head .Button--close path {
  stroke: #fff;
}
.Modal--Receipt .Modal__head h2 {
  display: none;
}
.Modal--Receipt .Modal__body {
  position: unset;
  padding: 0;
}
.Modal--Receipt .Modal__footer {
  position: relative;
}
.Modal--Receipt .Modal__footer .Button--primary {
  background-color: #1db0ea;
}
.Modal--Receipt .Icon--receipt-shape {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
@media (max-width: 480px) {
  .Modal--Receipt .Icon--receipt-shape {
    top: -20px;
    right: -20px;
  }
}
.Modal .label {
  font-size: 0.875rem;
  color: #252b37;
  padding-left: 6px;
  font-weight: 500;
  margin-bottom: 8px;
}
.Modal .label:not(:last-child) {
  margin-bottom: 8px;
}
.Modal .error {
  display: block;
  margin-top: 4px;
  padding-left: 6px;
  color: #f04438;
  font-size: 0.875rem;
  font-weight: 500;
}
.Modal .Input {
  width: 100% !important;
  padding: 16px;
}
.Modal .Input::placeholder {
  color: #afafaf;
}
.Modal .react-datepicker__input-container {
  width: 100%;
}
.Modal .react-datepicker__input-container input {
  font-size: 0.875rem;
  background-color: #f9fafa;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  font-weight: 500;
  height: 40px;
  padding: 16px;
  outline: none;
}
.Modal .Icon--calendar {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}
.Modal .Icon--calendar svg rect,
.Modal .Icon--calendar svg path {
  stroke: #ccc;
}
.Modal .groupColumns {
  padding: 25px 0 34px 0;
  border-top: 2px solid #f3f3f3;
}
.Modal .groupColumns:first-child {
  border: none;
}
.Modal .groupColumns:last-child {
  padding-bottom: 0;
}
.Modal .groupColumns__title {
  color: #252b37;
  font-weight: 600;
  font-size: 1.125rem;
  padding-bottom: 16px;
}
.Modal .groupColumns .groupColumnsFour {
  display: grid;
  grid-template-columns: repeat(4, 214px);
  gap: 20px;
}
.Modal .groupColumns .groupColumnsTwo {
  display: grid;
  grid-template-columns: repeat(2, 214px);
  gap: 80px;
}
.Modal .groupColumns .Input-wrapper {
  width: 100%;
}
.Modal .notifications-title {
  padding-bottom: 45px;
}
.Modal .addressFirst {
  grid-area: 1/1/1/3;
}
.Modal .addressSecond {
  grid-area: 1/3/1/5;
}
@media (max-width: 480px) {
  .Modal .Button--primary {
    width: 100%;
  }
}
@media (max-width: 390px) {
  .Modal .Button--NewPatient {
    width: 100%;
  }
}
.Modal__fixed-wrapper {
  position: relative;
  height: 100vh;
}
.Modal--close {
  width: 24px;
  height: 24px;
}

.ModalRightOverlay {
  transition: 0.3s ease-in-out;
  justify-content: flex-end;
  background: transparent;
}
.ModalRightOverlay.ReactModal__Overlay--after-open {
  background-color: rgba(0, 0, 0, 0.4);
}
.ModalRightOverlay.ReactModal__Overlay--before-close {
  background-color: transparent;
}
.ModalRightOverlay .ReactModal__Content {
  transition: 0.3s ease-in-out;
  transform: translateX(100%);
  height: 100%;
}
.ModalRightOverlay .ReactModal__Content--after-open {
  transform: translateX(0);
}
.ModalRightOverlay .ReactModal__Content--before-close {
  transform: translateX(100%);
}

.ModalBottomOverlay {
  transition: 0.3s ease-in-out;
  align-items: flex-end;
  background: transparent;
}
.ModalBottomOverlay.ReactModal__Overlay--after-open {
  background-color: rgba(0, 0, 0, 0.4);
}
.ModalBottomOverlay.ReactModal__Overlay--before-close {
  background-color: transparent;
}
.ModalBottomOverlay .ReactModal__Content {
  transition: 0.3s ease-in-out;
  transform: translateY(100%);
  box-sizing: border-box;
}
.ModalBottomOverlay .ReactModal__Content--after-open {
  transform: translateY(0);
}
.ModalBottomOverlay .ReactModal__Content--before-close {
  transform: translateY(100%);
}

.ModalCenterAnimation {
  transition: 0.3s ease-in-out;
  background: transparent;
}
.ModalCenterAnimation.ReactModal__Overlay--after-open {
  background-color: rgba(0, 0, 0, 0.5);
}
.ModalCenterAnimation.ReactModal__Overlay--before-close {
  background-color: transparent;
}
.ModalCenterAnimation .ReactModal__Content {
  transition: 0.1s ease-in-out;
  transform: scale(0.5);
}
.ModalCenterAnimation .ReactModal__Content--after-open {
  transform: scale(1);
}
.ModalCenterAnimation .ReactModal__Content--before-close {
  transition: 0.2s ease-in-out;
  transform: scale(0);
}

.ConfirmOverlay {
  z-index: 250 !important;
  transition: background-color 0.2s ease-in-out;
  background-color: transparent;
}
.ConfirmOverlay.ReactModal__Overlay--after-open {
  background-color: rgba(0, 0, 0, 0.5);
}
.ConfirmOverlay.ReactModal__Overlay--before-close {
  background-color: transparent;
}
.ConfirmOverlay .ReactModal__Content {
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
  opacity: 0;
  transform: scale(0.96);
}
.ConfirmOverlay .ReactModal__Content--after-open {
  opacity: 1;
  transform: scale(1);
}
.ConfirmOverlay .ReactModal__Content--before-close {
  opacity: 0;
  transform: scale(0.96);
}`, "",{"version":3,"sources":["webpack://./src/components/shared/Modal/lib/Modal.scss","webpack://./src/styles/_lib.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;AAFF;ACEE;EDXF;IAcI,UAAA;EADF;AACF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,iCAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AADF;ACAE;EDPF;IAWI,UAAA;EAAF;AACF;ACZE;EDAF;IAcI,gBAAA;IACA,WAAA;EAEF;AACF;ACzBE;EDOF;IAkBI,gBAAA;IACA,WAAA;EAIF;EAFE;IACE,gBAAA;EAIJ;AACF;AADE;EACE,cAAA;EACA,gBAAA;ECwCF,mBAViB;AD1BnB;AAFI;EACE,0BAAA;AAIN;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,sBAAA;EAAA,4DAAA;EACA,UAAA;EAEA,YAAA;AACJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AADN;AAEM;EACE,iBAAA;AAAR;AAGQ;EACE,yBAAA;AADV;AAOE;EACE,gBAAA;EACA,kBAAA;AALJ;AAMI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAJN;AAKM;EACE,aAAA;AAHR;AAKM;EACE,gBAAA;ECTN,mBAViB;ADiBnB;AAKM;EACE,WAAA;ECbN,mBAViB;ADqBnB;AAKM;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;ECnBN,mBAViB;ED+BX,gCE9FI;EF+FJ,cE6KA;EF5KA,YAAA;AAHR;AAIQ;EACE,wBAAA;AAFV;AAIQ;EACE,cEuKF;AFzKR;AAQE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EAAA,4DAAA;EACA,sBAAA;AANJ;AAQM;EACE,uBAAA;EACA,cE0JI;AFhKZ;AAOQ;EACE,mBEyJG;AF9Jb;AAQM;EACE,cAAA;AANR;AAOQ;EACE,yBAAA;AALV;AAWE;EACE,WAAA;EACA,iBAAA;AATJ;AC3GE;EDkHA;IAII,gBAAA;EAPJ;AACF;ACvHE;EDyHA;IAOI,gBAAA;IACA,UAAA;EALJ;AACF;ACpIE;EDgIA;IAWI,UAAA;EAHJ;AACF;AAII;EACE,UAAA;EACA,gBAAA;AAFN;AAGM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,6BAAA;AADR;AC3JE;EDuJI;IAOI,SAAA;IACA,WAAA;EACR;AACF;AAAQ;EACE,YAAA;AAEV;AACM;EACE,aAAA;AACR;AAEI;EACE,eAAA;EACA,UAAA;AAAN;AAEI;EACE,kBAAA;AAAN;AACM;EACE,yBAAA;AACR;AAEI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;AAAN;ACvLE;EDmLE;IAMI,UAAA;IACA,YAAA;EAEN;AACF;AAEE;ECpHA,mBAViB;EDgIf,cE6EI;EF5EJ,iBAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;AACI;EACE,kBAAA;AACN;AAGE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cEyEK;ED5MP,mBAViB;ED+If,gBAAA;AADJ;AAIE;EACE,sBAAA;EACA,aAAA;AAFJ;AAGI;EACE,cAAA;AADN;AAKE;EACE,WAAA;AAHJ;AAII;EClJF,mBAViB;ED8Jb,yBEqDO;EFpDP,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;AAFN;AAME;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AAJJ;AAMM;;EAEE,YAAA;AAJR;AASE;EACE,sBAAA;EACA,6BAAA;AAPJ;AAQI;EACE,YAAA;AANN;AAQI;EACE,iBAAA;AANN;AAQI;EACE,cEcE;EFbF,gBAAA;ECtLJ,mBAViB;EDkMb,oBAAA;AANN;AAQI;EACE,aAAA;EACA,uCAAA;EACA,SAAA;AANN;AAQI;EACE,aAAA;EACA,uCAAA;EACA,SAAA;AANN;AAQI;EACE,WAAA;AANN;AASE;EACE,oBAAA;AAPJ;AASE;EACE,kBAAA;AAPJ;AASE;EACE,kBAAA;AAPJ;ACnRE;ED6RE;IAEI,WAAA;EARN;AACF;AC/RE;EDySE;IAEI,WAAA;EARN;AACF;AAWE;EACE,kBAAA;EACA,aAAA;AATJ;AAWE;EACE,WAAA;EACA,YAAA;AATJ;;AAaA;EACE,4BAAA;EACA,yBAAA;EACA,uBAAA;AAVF;AAWE;EACE,oCAAA;AATJ;AAWE;EACE,6BAAA;AATJ;AAWE;EACE,4BAAA;EACA,2BAAA;EACA,YAAA;AATJ;AAWE;EACE,wBAAA;AATJ;AAWE;EACE,2BAAA;AATJ;;AAaA;EACE,4BAAA;EACA,qBAAA;EACA,uBAAA;AAVF;AAWE;EACE,oCAAA;AATJ;AAWE;EACE,6BAAA;AATJ;AAWE;EACE,4BAAA;EACA,2BAAA;EACA,sBAAA;AATJ;AAWE;EACE,wBAAA;AATJ;AAWE;EACE,2BAAA;AATJ;;AAaA;EACE,4BAAA;EACA,uBAAA;AAVF;AAWE;EACE,oCAAA;AATJ;AAWE;EACE,6BAAA;AATJ;AAWE;EACE,4BAAA;EACA,qBAAA;AATJ;AAWE;EACE,mBAAA;AATJ;AAWE;EACE,4BAAA;EACA,mBAAA;AATJ;;AAaA;EAGE,uBAAA;EACA,6CAAA;EACA,6BAAA;AAZF;AAaE;EACE,oCAAA;AAXJ;AAaE;EACE,6BAAA;AAXJ;AAaE;EACE,gEACE;EAEF,UAAA;EACA,sBAAA;AAbJ;AAeE;EACE,UAAA;EACA,mBAAA;AAbJ;AAeE;EACE,UAAA;EACA,sBAAA;AAbJ","sourcesContent":["@use '../../../../styles/lib' as lib;\n@use '../../../../styles/variables' as var;\n\n.ModalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 100;\n  padding: 16px;\n\n  @include lib.xs {\n    padding: 0;\n  }\n}\n\n.Modal {\n  position: relative;\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  box-sizing: border-box;\n  background: white;\n  border-radius: 8px;\n  outline: none;\n  overflow: hidden;\n\n  @include lib.md {\n    width: 90%;\n  }\n  @include lib.sm {\n    min-width: unset;\n    width: 100%;\n  }\n  @include lib.xs {\n    min-width: unset;\n    width: 100%;\n    // Side / bottom sheets go edge to edge on phones; centered modals keep their rounded corners.\n    &:not(.Modal--centered) {\n      border-radius: 0;\n    }\n  }\n\n  h2 {\n    color: #374145;\n    font-weight: 500;\n    @include lib.rem(font-size, 18px);\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n\n  &__head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    border-bottom: 1px;\n    border-bottom-style: solid;\n    @apply border-neutral-200;\n    z-index: 1;\n    // This is to prevent the modal from overflowing the container.\n    min-width: 0;\n    // In CSS Grid, the default min-width for grid children is auto, which means they won't shrink below their content size.\n    // Setting min-width: 0 allows them to shrink and respect the container's width, enabling text truncation, wrapping, or ellipsis as you wish.\n\n    &__left {\n      display: flex;\n      align-items: center;\n      overflow: hidden;\n      width: 100%;\n      .Button {\n        margin-left: 30px;\n      }\n      * {\n        &::first-letter {\n          text-transform: uppercase;\n        }\n      }\n    }\n  }\n\n  &__body {\n    overflow-y: auto;\n    overflow-x: hidden;\n    .group-wrapper {\n      display: grid;\n      align-items: center;\n      grid-template-columns: 3fr 9fr;\n      margin-top: 20px;\n      &:first-child {\n        margin-top: 0;\n      }\n      label {\n        line-height: 1.1;\n        @include lib.rem(font-size, 14px);\n      }\n      .react-datepicker__input-container input {\n        width: 100%;\n        @include lib.rem(font-size, 14px);\n      }\n      textarea {\n        border-radius: 6px;\n        border: 1px solid var.$gray-dark;\n        padding: 8px 10px;\n        @include lib.rem(font-size, 14px);\n        font-family: var.$main-font;\n        color: var.$black;\n        resize: none;\n        &:focus {\n          outline: none !important;\n        }\n        &::placeholder {\n          color: var.$black;\n        }\n      }\n    }\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 20px;\n    padding: 12px 16px;\n    border-top: 1px;\n    border-top-style: solid;\n    @apply border-neutral-200;\n    background-color: #fff;\n    .Button {\n      &--secondary {\n        background: transparent;\n        color: var.$gray-dark;\n        &:hover {\n          background: var.$gray-light;\n        }\n      }\n      &--transparent {\n        color: #aaaaaa;\n        &:hover {\n          background-color: #efefef;\n        }\n      }\n    }\n  }\n\n  &--Receipt {\n    width: auto;\n    min-width: 1000px;\n    @include lib.lg {\n      min-width: 900px;\n    }\n    @include lib.md {\n      min-width: unset;\n      width: 90%;\n    }\n    @include lib.sm {\n      width: 96%;\n    }\n    .Modal__head {\n      padding: 0;\n      border-bottom: 0;\n      .Button--close {\n        position: absolute;\n        top: 20px;\n        right: 40px;\n        z-index: 2;\n        background-color: transparent;\n        @include lib.xs {\n          top: 14px;\n          right: 34px;\n        }\n        path {\n          stroke: #fff;\n        }\n      }\n      h2 {\n        display: none;\n      }\n    }\n    .Modal__body {\n      position: unset;\n      padding: 0;\n    }\n    .Modal__footer {\n      position: relative;\n      .Button--primary {\n        background-color: #1db0ea;\n      }\n    }\n    .Icon--receipt-shape {\n      position: absolute;\n      top: 0;\n      right: 0;\n      z-index: 1;\n      @include lib.xs {\n        top: -20px;\n        right: -20px;\n      }\n    }\n  }\n\n  .label {\n    @include lib.rem(font-size, 14px);\n    color: var.$black;\n    padding-left: 6px;\n    font-weight: 500;\n    margin-bottom: 8px;\n    &:not(:last-child) {\n      margin-bottom: 8px;\n    }\n  }\n\n  .error {\n    display: block;\n    margin-top: 4px;\n    padding-left: 6px;\n    color: var.$danger;\n    @include lib.rem(font-size, 14px);\n    font-weight: 500;\n  }\n\n  .Input {\n    width: 100% !important;\n    padding: 16px;\n    &::placeholder {\n      color: #afafaf;\n    }\n  }\n\n  .react-datepicker__input-container {\n    width: 100%;\n    input {\n      @include lib.rem(font-size, 14px);\n      background-color: var.$gray-light;\n      border: 1px solid #dcdcdc;\n      border-radius: 8px;\n      font-weight: 500;\n      height: 40px;\n      padding: 16px;\n      outline: none;\n    }\n  }\n\n  .Icon--calendar {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    svg {\n      rect,\n      path {\n        stroke: #ccc;\n      }\n    }\n  }\n\n  .groupColumns {\n    padding: 25px 0 34px 0;\n    border-top: 2px solid #f3f3f3;\n    &:first-child {\n      border: none;\n    }\n    &:last-child {\n      padding-bottom: 0;\n    }\n    &__title {\n      color: var.$black;\n      font-weight: 600;\n      @include lib.rem(font-size, 18px);\n      padding-bottom: 16px;\n    }\n    .groupColumnsFour {\n      display: grid;\n      grid-template-columns: repeat(4, 214px);\n      gap: 20px;\n    }\n    .groupColumnsTwo {\n      display: grid;\n      grid-template-columns: repeat(2, 214px);\n      gap: 80px;\n    }\n    .Input-wrapper {\n      width: 100%;\n    }\n  }\n  .notifications-title {\n    padding-bottom: 45px;\n  }\n  .addressFirst {\n    grid-area: 1/1/1/3;\n  }\n  .addressSecond {\n    grid-area: 1/3/1/5;\n  }\n  .Button {\n    &--primary {\n      @include lib.xs {\n        width: 100%;\n      }\n    }\n    &--NewPatient {\n      @include lib.xxs {\n        width: 100%;\n      }\n    }\n  }\n  &__fixed-wrapper {\n    position: relative;\n    height: 100vh;\n  }\n  &--close {\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.ModalRightOverlay {\n  transition: 0.3s ease-in-out;\n  justify-content: flex-end;\n  background: transparent;\n  &.ReactModal__Overlay--after-open {\n    background-color: rgba(0, 0, 0, 0.4);\n  }\n  &.ReactModal__Overlay--before-close {\n    background-color: transparent;\n  }\n  .ReactModal__Content {\n    transition: 0.3s ease-in-out;\n    transform: translateX(100%);\n    height: 100%;\n  }\n  .ReactModal__Content--after-open {\n    transform: translateX(0);\n  }\n  .ReactModal__Content--before-close {\n    transform: translateX(100%);\n  }\n}\n\n.ModalBottomOverlay {\n  transition: 0.3s ease-in-out;\n  align-items: flex-end;\n  background: transparent;\n  &.ReactModal__Overlay--after-open {\n    background-color: rgba(0, 0, 0, 0.4);\n  }\n  &.ReactModal__Overlay--before-close {\n    background-color: transparent;\n  }\n  .ReactModal__Content {\n    transition: 0.3s ease-in-out;\n    transform: translateY(100%);\n    box-sizing: border-box;\n  }\n  .ReactModal__Content--after-open {\n    transform: translateY(0);\n  }\n  .ReactModal__Content--before-close {\n    transform: translateY(100%);\n  }\n}\n\n.ModalCenterAnimation {\n  transition: 0.3s ease-in-out;\n  background: transparent;\n  &.ReactModal__Overlay--after-open {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n  &.ReactModal__Overlay--before-close {\n    background-color: transparent;\n  }\n  .ReactModal__Content {\n    transition: 0.1s ease-in-out;\n    transform: scale(0.5);\n  }\n  .ReactModal__Content--after-open {\n    transform: scale(1);\n  }\n  .ReactModal__Content--before-close {\n    transition: 0.2s ease-in-out;\n    transform: scale(0);\n  }\n}\n\n.ConfirmOverlay {\n  // Confirmations are always the topmost layer — above any stacked modal's\n  // overlay hack (z-[102]/z-[103]/z-[200]), replacing the old per-site z hacks.\n  z-index: 250 !important;\n  transition: background-color 0.2s ease-in-out;\n  background-color: transparent;\n  &.ReactModal__Overlay--after-open {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n  &.ReactModal__Overlay--before-close {\n    background-color: transparent;\n  }\n  .ReactModal__Content {\n    transition:\n      opacity 0.2s ease-in-out,\n      transform 0.2s ease-in-out;\n    opacity: 0;\n    transform: scale(0.96);\n  }\n  .ReactModal__Content--after-open {\n    opacity: 1;\n    transform: scale(1);\n  }\n  .ReactModal__Content--before-close {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n}\n","@use './variables' as var;\n@use 'sass:math';\n@use 'sass:list';\n@use 'sass:meta';\n\n//Mixin for including styles under 390px\n@mixin xxs {\n  @media (max-width: var.$xxs) {\n    @content;\n  }\n}\n\n//Mixin for including styles under 480px\n@mixin xs {\n  @media (max-width: var.$xs) {\n    @content;\n  }\n}\n\n//Mixin for including styles under 768px\n@mixin sm {\n  @media (max-width: var.$sm) {\n    @content;\n  }\n}\n\n//Mixin for including styles under 1024x\n@mixin md {\n  @media (max-width: var.$md) {\n    @content;\n  }\n}\n\n//Mixin for including styles under 1512px\n@mixin lg {\n  @media (max-width: var.$lg) {\n    @content;\n  }\n}\n\n//Mixin for including styles above 1513px\n@mixin xl {\n  @media (min-width: var.$xl) {\n    @content;\n  }\n}\n\n// Mixin for including styles above 2001px\n@mixin xxl {\n  @media (min-width: var.$xxl) {\n    @content;\n  }\n}\n\n// Mixin for converting 'px' to 'rem'\n@mixin rem($property, $values) {\n  // Create a couple of empty lists as output buffers.\n  $base-font-size: 16px; // should be consistent with your html/body font-size\n  $px-values: ();\n  $rem-values: ();\n\n  // Loop through the $values list\n  @each $value in $values {\n    // For each property value, if it's in rem or px, derive both rem and\n    // px values for it and add those to the end of the appropriate buffer.\n    // Ensure all pixel values are rounded to the nearest pixel.\n    @if $value==0 or $value==0px {\n      // 0 -- use it without a unit\n      $px-values: list.join($px-values, 0);\n      $rem-values: list.join($rem-values, 0);\n    } @else if\n      meta.type-of($value)\n      ==number and not\n      math.is-unitless($value) and\n      (math.unit($value) ==px)\n    {\n      // px value given - calculate rem value from base-font-size\n      $new-rem-value: calc($value / $base-font-size);\n      $px-values: list.join($px-values, math.round($value));\n      $rem-values: list.join($rem-values, #{$new-rem-value}rem);\n    } @else {\n      // unitless value - use those directly as rem and calculate the px-fallback\n      $px-values: list.join($px-values, math.round($value * $base-font-size));\n      $rem-values: list.join($rem-values, #{$value}rem);\n    }\n  }\n\n  // output the converted rules\n  // #{$property}: $px-values;\n  #{$property}: $rem-values;\n}\n\n@mixin scrollbar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    background: #eceff0;\n    border-radius: 5px;\n    display: block;\n  }\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px white;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #cdd5d8;\n    border-radius: 5px;\n  }\n\n  &-sm-light {\n    &::-webkit-scrollbar {\n      width: 4px;\n      height: 4px;\n      background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #e3eaed !important;\n    }\n  }\n}\n\n@mixin scrollbar-horizontal {\n  &::-webkit-scrollbar {\n    background: #eceff0;\n    border-radius: 5px;\n    display: block;\n    height: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px white;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #cdd5d8;\n    border-radius: 5px;\n  }\n}\n\n$scrollbar-color: #8fa0a7;\n\n@mixin app-scrollbar {\n  &::-webkit-scrollbar {\n    width: 12px;\n    height: 12px;\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $scrollbar-color;\n    border-radius: 24px;\n    border: 2px solid transparent;\n    background-clip: content-box;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    border-width: 0px;\n  }\n}\n","@use 'sass:map';\n\n$font-family-sans-serif:\n  'Geist',\n  -apple-system,\n  BlinkMacSystemFont,\n  'Segoe UI',\n  Roboto,\n  'Helvetica Neue',\n  Arial,\n  'Noto Sans',\n  sans-serif,\n  'Apple Color Emoji',\n  'Segoe UI Emoji',\n  'Segoe UI Symbol',\n  'Noto Color Emoji' !default;\n$main-font: 'Geist', sans-serif;\n\n// colors — kept in sync with tailwind.config.js\n$colors: (\n  'neutral': (\n    25: #fdfdfd,\n    50: #f9fafa,\n    75: #f6f6f6,\n    100: #f5f5f5,\n    200: #e9eaeb,\n    300: #d5d7da,\n    400: #a4a7ae,\n    500: #717680,\n    600: #535862,\n    700: #414651,\n    800: #252b37,\n    900: #181d27,\n    950: #0a0d12\n  ),\n  'neutral-dark': (\n    25: #fafafa,\n    50: #f7f7f7,\n    100: #f0f0f1,\n    200: #ececed,\n    300: #cecfd2,\n    400: #94979c,\n    500: #85888e,\n    600: #61656c,\n    700: #373a41,\n    800: #22262f,\n    900: #13161b,\n    950: #0c0e12\n  ),\n  'primary': (\n    10: #fafdff,\n    25: #f5fbff,\n    50: #f0f9ff,\n    100: #e0f2fe,\n    200: #b9e6fe,\n    300: #7cd4fd,\n    400: #36bffa,\n    500: #0ba5ec,\n    600: #0086c9,\n    700: #026aa2,\n    800: #065986,\n    900: #0b4a6f,\n    950: #062c41\n  ),\n  'danger': (\n    25: #fffbfa,\n    50: #fef3f2,\n    100: #fee4e2,\n    200: #fecdca,\n    300: #fda29b,\n    400: #f97066,\n    500: #f04438,\n    600: #d92d20,\n    700: #b42318,\n    800: #912018,\n    900: #7a271a,\n    950: #55160c\n  ),\n  'warning': (\n    25: #fffcf5,\n    50: #fffaeb,\n    100: #fef0c7,\n    200: #fedf89,\n    300: #fec84b,\n    400: #fdb022,\n    500: #f79009,\n    600: #dc6803,\n    700: #b54708,\n    800: #93370d,\n    900: #7a2e0e,\n    950: #4e1d09\n  ),\n  'success': (\n    25: #f6fef9,\n    50: #edfcf2,\n    100: #d3f8df,\n    200: #aaf0c4,\n    300: #73e2a3,\n    400: #3ccb7f,\n    500: #16b364,\n    600: #099250,\n    700: #087443,\n    800: #095c37,\n    900: #084c2e,\n    950: #052e1c\n  ),\n  'moss': (\n    25: #fafdf7,\n    50: #f5fbee,\n    100: #e6f4d7,\n    200: #ceeab0,\n    300: #acdc79,\n    400: #86cb3c,\n    500: #669f2a,\n    600: #4f7a21,\n    700: #3f621a,\n    800: #335015,\n    900: #2b4212,\n    950: #1a280b\n  ),\n  'green-light': (\n    25: #fafef5,\n    50: #f3fee7,\n    100: #e4fbcc,\n    200: #d0f8ab,\n    300: #a6ef67,\n    400: #85e13a,\n    500: #66c61c,\n    600: #4ca30d,\n    700: #3b7c0f,\n    800: #326212,\n    900: #2b5314,\n    950: #15290a\n  ),\n  'teal': (\n    25: #f6fefc,\n    50: #f0fdf9,\n    100: #ccfbef,\n    200: #99f6e0,\n    300: #5fe9d0,\n    400: #2ed3b7,\n    500: #15b79e,\n    600: #0e9384,\n    700: #107569,\n    800: #125d56,\n    900: #134e48,\n    950: #0a2926\n  ),\n  'cyan': (\n    25: #f5feff,\n    50: #ecfdff,\n    100: #cff9fe,\n    200: #a5f0fc,\n    300: #67e3f9,\n    400: #22ccee,\n    500: #06aed4,\n    600: #088ab2,\n    700: #0e7090,\n    800: #155b75,\n    900: #164c63,\n    950: #0d2d3a\n  ),\n  'blue-dark': (\n    25: #f5f8ff,\n    50: #eff4ff,\n    100: #d1e0ff,\n    200: #b2ccff,\n    300: #84adff,\n    400: #528bff,\n    500: #2970ff,\n    600: #155eef,\n    700: #004eeb,\n    800: #0040c1,\n    900: #00359e,\n    950: #002266\n  ),\n  'violet': (\n    25: #fbfaff,\n    50: #f5f3ff,\n    100: #ece9fe,\n    200: #ddd6fe,\n    300: #c3b5fd,\n    400: #a48afb,\n    500: #875bf7,\n    600: #7839ee,\n    700: #6927da,\n    800: #5720b7,\n    900: #491c96,\n    950: #2e125e\n  ),\n  'purple': (\n    25: #fafaff,\n    50: #f4f3ff,\n    100: #ebe9fe,\n    200: #d9d6fe,\n    300: #bdb4fe,\n    400: #9b8afb,\n    500: #7a5af8,\n    600: #6938ef,\n    700: #5925dc,\n    800: #4a1fb8,\n    900: #3e1c96,\n    950: #27115f\n  ),\n  'fuchsia': (\n    25: #fefaff,\n    50: #fdf4ff,\n    100: #fbe8ff,\n    200: #f6d0fe,\n    300: #eeaafd,\n    400: #e478fa,\n    500: #d444f1,\n    600: #ba24d5,\n    700: #9f1ab1,\n    800: #821890,\n    900: #6f1877,\n    950: #47104c\n  ),\n  'pink': (\n    25: #fef6fb,\n    50: #fdf2fa,\n    100: #fce7f6,\n    200: #fcceee,\n    300: #faa7e0,\n    400: #f670c7,\n    500: #ee46bc,\n    600: #dd2590,\n    700: #c11574,\n    800: #9e165f,\n    900: #851651,\n    950: #4e0d30\n  ),\n  'rose': (\n    25: #fff5f6,\n    50: #fff1f3,\n    100: #ffe4e8,\n    200: #fecdd6,\n    300: #fea3b4,\n    400: #fd6f8e,\n    500: #f63d68,\n    600: #e31b54,\n    700: #c01048,\n    800: #a11043,\n    900: #89123e,\n    950: #510b24\n  ),\n  'orange-dark': (\n    25: #fff9f5,\n    50: #fff4ed,\n    100: #ffe6d5,\n    200: #ffd6ae,\n    300: #ff9c66,\n    400: #ff692d,\n    500: #ff4405,\n    600: #e62e05,\n    700: #bc1b06,\n    800: #97180c,\n    900: #771a0d,\n    950: #57130a\n  ),\n  'yellow': (\n    25: #fefdf0,\n    50: #fefbe8,\n    100: #fef7c3,\n    200: #feee95,\n    300: #fde272,\n    400: #fac515,\n    500: #eaaa08,\n    600: #ca8504,\n    700: #a15c07,\n    800: #854a0e,\n    900: #713b12,\n    950: #542c0d\n  ),\n  'white': (\n    500: #ffffff\n  ),\n  'black': (\n    500: #000000\n  )\n);\n\n//colors\n$dark: map.get(map.get($colors, 'neutral'), 900);\n$black: map.get(map.get($colors, 'neutral'), 800);\n$primary: var(--color-primary-500, #{map.get(map.get($colors, 'primary'), 500)});\n$primary-dark: map.get(map.get($colors, 'primary'), 900);\n$secondary: var(--color-secondary-500, #b0d5e2);\n$gray: map.get(map.get($colors, 'neutral'), 400);\n$gray-dark: map.get(map.get($colors, 'neutral'), 800);\n$gray-light: map.get(map.get($colors, 'neutral'), 50);\n$success: map.get(map.get($colors, 'success'), 500);\n$warning: map.get(map.get($colors, 'warning'), 500);\n$danger: map.get(map.get($colors, 'danger'), 500);\n$blue-light: #f8fdff;\n$blue: #4876ff;\n\n//card theme colors\n$yellow: #ffc700;\n$purple: #aa56ff;\n$green: #00bf93;\n$greenLight: #10ca00;\n\n//media queries\n$xxs: 390px;\n$xs: 480px;\n$sm: 768px;\n$md: 1024px;\n$lg: 1512px;\n$xl: 1513px;\n$xxl: 2001px;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
